import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Company } from '../../../models/Company.model';
import { CompaniesService } from '../../../services/companies.service';
import { CompanyGroup } from "../../../models/CompanyGroup.model";
import { CompanyGroupSearch } from "../../..//models/CompanyGroupSearch.model";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { Router } from '@angular/router';
import { ToastsManager } from "ng2-toastr";
import * as moment from 'moment';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { AwsService } from '../../../services/aws.service';
import { GUARDS } from '../../../shared/auth/Roles';

@Component({
  selector: 'app-company-group',
  templateUrl: './company-group.component.html',
  styleUrls: ['./company-group.component.css']
})
export class CompanyGroupComponent implements OnInit {

  @ViewChild('uploadInput') uploadInput:ElementRef;
  itemsPerPage: number[] = [10, 50, 100];
  totalItems: number = 0;
  currentPage: number = 0;

  name: string;
  nameEdit: string;
  groupForm: FormGroup;
  company: Company = new Company();
  companies: Company[] = [];
  companyGroup: CompanyGroup = new CompanyGroup();

  companyGroups: CompanyGroup[] = null;
  commonHelper: CommonHelper = new CommonHelper();
  companyGroupSearchModel: CompanyGroupSearch;
  loading: boolean;
  selectedFiles:FileList;
  fileList;
  downloadUrl: string = '';

  canSave: Boolean = true;
  allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.JUDICIARY, GUARDS.FINANCES, GUARDS.DP];
  user;

  constructor(private companiesService: CompaniesService,
    private formBuilder: FormBuilder,
    private router: Router,
    private tostr: ToastsManager,
    private localStorage: LocalStorage,
    private awsService: AwsService) { }


  async ngOnInit() {
    this.loading = true;

    this.checkPermissions();

    this.groupForm = this.formBuilder.group({
      name: [null, Validators.required],
    });
    this.companyGroupSearchModel = this.localStorage.retrieve('companyGroup') ? this.localStorage.retrieve('companyGroup') : new CompanyGroupSearch();
    await this.searchListGroups(1);
    this.loading = false;
  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    if(!this.allowedRoles.includes(this.user.permission)) {
        this.canSave = false;
    }
  }

  async OnSave() {
    if (this.groupForm.valid) {
      try{
          let response = await this.companiesService.createGroup(this.companyGroup);
          if(response._id){

            if(this.selectedFiles)
              this.uploadCreate(response._id);

            this.OnClear();
            await this.searchListGroups(1);
            this.tostr.success('Grupo de empresa criado com sucesso!');
          }
        } catch (err) {
          this.router.navigate(['/companies/group']);
          this.tostr.error("Erro ao cadastrar grupo de empresa!");
        }
      }
  }

  @HostListener('window:keyup', ['$event'])
  async keyEvent(event: KeyboardEvent) {
      if (event.keyCode === 13) {
            await this.searchListGroups(1);
        }
    }

  OnClear() {
    this.companyGroup = new CompanyGroup();
    this.uploadInput.nativeElement.value = '';
  }

  uploadCreate(id) {
    let length = this.selectedFiles.length;
    for(let i=0; i<length; i++){
      const file = this.selectedFiles.item(i);
        this.awsService.uploadfile(file,id);
    }
  }

  async uploadEdit(id) {
    try {
      let length = this.selectedFiles.length;
      for(let i=0; i<length; i++){
        const file = this.selectedFiles.item(i);
        await this.awsService.uploadfile(file,id);
      }

      await this.getS3Files(id);
    } catch (error) {
      console.log(error);
    }
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  async getS3Files(id){
    this.fileList = await this.awsService.getFiles(id);
  };

  async deleteFile(name, id){
    await this.awsService.deleteFile(name);
    await this.getS3Files(id);
  }

  async download(name){
    this.downloadUrl = await this.awsService.download(name);
  }

  async edit(cg){
    let response = await this.companiesService.editGroup(cg, this.nameEdit);
    this.nameEdit = '';
  }

  async searchListGroups(page?: number) {
    this.loading = true;
    this.currentPage = page ? page : 1;
    this.companyGroupSearchModel.skip = (page - 1) * this.companyGroupSearchModel.limit;
    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);
    this.totalItems = this.companyGroupSearchModel.totalItems;
    this.localStorage.persist('companyGroup',this.companyGroupSearchModel);
    this.loading = false;
  }

  async getCompaniesByGroupId(companyGroup){
    this.companies = await this.companiesService.getCompaniesByGroupId(companyGroup._id);
    await this.getS3Files(companyGroup._id);
  }

  verifyValidTouched(fieldName) {
    return !this.groupForm.get(fieldName).valid && this.groupForm.get(fieldName).touched;
  }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-group/company-group.component.ts